import { render } from "./WritingComp.vue?vue&type=template&id=01351446"
import script from "./WritingComp.vue?vue&type=script&lang=js"
export * from "./WritingComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__